import React from "react";

import { EsgFileIcon } from "assets";

export const DOCUMENT_UPLOAD_PAGE = {
  ABSOLUTE_PATH: "/documents",
  PATH: "",
  TITLE: "Document upload",
  ICON: <EsgFileIcon />,
  renderMenu: true,
};

export const BASE_DATA_ENTRIES = [
  {
    "label": "Warning (Conversion Error)",
    "name": "Warning (Conversion Error)",
    "value": 1
  },
  {
    "label": "Warning (Missing Fields)",
    "name": "Warning (Missing Fields)",
    "value": 2
  },
  {
    "label": "Warning (Potential Error Identified)",
    "name": "Warning (Potential Error Identified)",
    "value": 3
  },
  {
    "label": "Emissions Included (AI Generated)",
    "name": "Emissions Included (AI Generated)",
    "value": 4
  },
  {
    "label": "Emissions Included (User Confirmed)",
    "name": "Emissions Included (User Confirmed)",
    "value": 5
  },
];

export const ACTIVE_FLOW_DATA_ENTRIES = [
  ...BASE_DATA_ENTRIES,
  {
    "label": "Emissions Included (Excel Upload)",
    "name": "Emissions Included (Excel Upload)",
    "value": 9
  },
  {
    "label": "Reviewed",
    "name": "Reviewed",
    "value": 6
  },
  {
    "label": "Approved (Signed Off)",
    "name": "Approved (Signed Off)",
    "value": 7
  },
  {
    "label": "Approved (Locked)",
    "name": "Approved (Locked)",
    "value": 8
  },
]

export const INACTIVE_FLOW_DATA_ENTRIES = [
  ...BASE_DATA_ENTRIES,
  {
    "label": "Emissions Included (Excel Upload)",
    "name": "Emissions Included (Excel Upload)",
    "value": 8
  },
  {
    "label": "Approved (Signed Off)",
    "name": "Approved (Signed Off)",
    "value": 6
  },
  {
    "label": "Approved (Locked)",
    "name": "Approved (Locked)",
    "value": 7
  },
]

export const DATA_ENTRIES_STATUS_PRIORITY_MAP: Record<string, number> = {
  "Warning (Conversion Error)": 0,
  "Warning (Missing Fields)": 1,
  "Warning (Potential Error Identified)": 2,
  "Emissions Included (AI Generated)": 3,
  "Emissions Included (User Confirmed)": 4,
  "Approved (Signed Off)": 5,
  "Approved (Locked)": 6,
  "Reviewed": 7,
  "Emissions Included (Excel Upload)": 8,
};

